import { render, staticRenderFns } from "./editMachinePrinter.vue?vue&type=template&id=0b245752"
import script from "./editMachinePrinter.vue?vue&type=script&lang=js"
export * from "./editMachinePrinter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports